<template>
  <Transition name="fade"><div v-if="detailModal" class="modal-backdrop" @click.self="detailModal = null"><div class="detail-modal"><button class="modal-close" aria-label="关闭" @click="detailModal = null">×</button><span class="detail-icon">✓</span><h2>{{ detailModal.title }}</h2><p>{{ detailModal.text }}</p><div class="detail-actions"><button @click="detailModal = null">稍后再说</button><button class="primary" @click="confirmDetail">确认</button></div></div></div></Transition>
</template>

<script setup>
import { useAppContext } from '../../composables/appContext'
const { confirmDetail, detailModal } = useAppContext()
</script>
